import { render } from "./MicrosoftEdge.svg?vue&type=template&id=6ab4565e"
const script = {}
script.render = render

export default script